import { render, staticRenderFns } from "./BancoForm.vue?vue&type=template&id=0437f1a4"
import script from "./BancoForm.vue?vue&type=script&lang=js"
export * from "./BancoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports